import React from 'react'
import { Form } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import { EnrolState } from 'enum'
import { IRequestCourseModel } from 'models/requestCourse.model'
import TextAreaInput from 'components/ui/forms/field/text-area/TextArea'
import StateEnrol from 'components/ui/state-enrol/StateEnrol'
import { useIsDesktop } from 'helpers'
import { prefix } from '../constants'
import styles from './common.module.scss'

interface RequestAdminProps {
  requestCourse: IRequestCourseModel
  text?: string
  value?: string
  onChange?: (value: string) => void
  canRespond?: boolean
}

export const RequestAdmin: React.FC<RequestAdminProps> = ({
  requestCourse,
  text,
  value,
  onChange,
  canRespond = false,
}) => {
  const { t } = useTranslation()

  const requestAdmin = requestCourse.stateAdmin === EnrolState.Pending
  const onDesktop = useIsDesktop()

  const title = (
    <p className={`${styles.title} grey-darken mt-1`}>
      {t(`${prefix}.adminResponseState`)}
    </p>
  )

  if (requestAdmin && canRespond) {
    return (
      <Form className="mt-2">
        <Form.Group className={styles.requestForm}>
          <Form.Label className={`${styles.formLabel} mb-0`}>
            {t(`${prefix}.adminResponseState`)}
          </Form.Label>
          <TextAreaInput
            name={'note'}
            placeholder={t(`${prefix}.placeholder`)}
            rows={5}
            label={''}
            value={value}
            onChange={({ target }) => onChange?.(target.value)}
            error={''}
          />
        </Form.Group>
      </Form>
    )
  }

  return (
    <>
      {onDesktop && <hr />}
      <div>
        {title}
        <StateEnrol
          className={styles.label}
          state={requestCourse.stateAdmin}
          iconPosition="right"
        />
        {text && <p className={`${styles.label} grey-darken mt-1`}>{text}</p>}
      </div>
    </>
  )
}

export default RequestAdmin
